// Единый расчёт прогресса курса — чтобы карточка «Общий прогресс» на Главной
// и «Всего пройдено» в разделе Прогресс показывали одни и те же цифры.
//
// Категории:
//   • вебинары  — из progress.lessonStatus, только НЕ ДЗ-блоки (isHomeworkOnly=false)
//   • ДЗ        — сданные ЗАДАНИЯ (уроки-ДЗ), а не отдельные номера
//   • варианты  — завершённые пробники
// Большое % — доля пройденного от всех занятий: (вебинары + ДЗ + варианты) пройдено / всего.
export function computeCourseProgress(progress, homeworks, variants) {
  const lessons = progress?.lessonStatus || [];
  const webins = lessons.filter(l => !l.isHomeworkOnly);
  const webTotal = webins.length;
  const webDone = webins.filter(l => l.status === 'viewed' || l.status === 'completed').length;

  const hwMap = {};
  (homeworks || []).forEach(h => {
    const lid = h.lessonId ?? h.Lesson?.id;
    if (lid == null) return;
    if (!(lid in hwMap)) hwMap[lid] = false;
    if (h.lessonCompleted) hwMap[lid] = true;
  });
  const hwKeys = Object.keys(hwMap);
  const hwTotal = hwKeys.length;
  const hwDone = hwKeys.filter(k => hwMap[k]).length;

  const varTotal = (variants || []).length;
  const varDone = (variants || []).filter(v => v.completed).length;

  const total = webTotal + hwTotal + varTotal;
  const pct = total ? Math.round(((webDone + hwDone + varDone) / total) * 100) : 0;

  return {
    pct,
    web: { done: webDone, total: webTotal },
    hw: { done: hwDone, total: hwTotal },
    variant: { done: varDone, total: varTotal },
  };
}
